import React from "react";
import { Container, Navbar, Nav} from 'react-bootstrap';
import {Link} from "react-router-dom";

function Header1() {
    return <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
            <Navbar.Brand href="#">EmergenTwin</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                    <Nav.Link as={Link} to="/" style={{ marginRight: '10px' }}>
                        Home
                    </Nav.Link>
                    <Nav.Link as={Link} to="/about" style={{ marginRight: '10px' }}>
                        About
                    </Nav.Link>
                    <Nav.Link as={Link} to="/contact" style={{ marginRight: '10px' }}>
                        Contact
                    </Nav.Link>
                    <Nav.Link as={Link} to="/login" style={{ marginRight: '10px' }}>
                        Login
                    </Nav.Link>
                    <Nav.Link as={Link} to="/register" style={{ marginRight: '10px' }}>
                        Register
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Container>
    </Navbar>;
}


export default Header1;